import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { KeymanList } from "./shared/KeymanList";
import { createKeymanListStyles } from "./shared/KeymanListStyles";

const ParentCorporationKeymanList = ({
  classes,
  isLoading,
  list,
  total,
  handleFilter,
  toggleDialog,
}) => {
  const isClickable = typeof handleFilter === "function";

  const handleItemClick = (item) => {
    if (handleFilter) {
      handleFilter();
      toggleDialog(item);
    }
  };

  const handleSearchClick = () => {
    if (handleFilter) {
      handleFilter();
      toggleDialog();
    }
  };

  return (
    <KeymanList
      classes={classes}
      isLoading={isLoading}
      list={list}
      total={total}
      displayCount={5} // eslint-disable-line no-magic-numbers
      title="親会社のキーマン"
      searchButtonText="親会社のキーマンを検索"
      isClickable={isClickable}
      onItemClick={handleItemClick}
      onSearchClick={handleSearchClick}
    />
  );
};

ParentCorporationKeymanList.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  list: PropTypes.array,
  total: PropTypes.number,
  handleFilter: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
  toggleDialog: PropTypes.func.isRequired,
};

ParentCorporationKeymanList.defaultProps = {
  handleFilter: null,
};

export default withStyles(createKeymanListStyles)(ParentCorporationKeymanList);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/ParentCorporationKeymanList.jsx